<template>
  <wx-open-launch-app
    id="launch-btn"
    @ready="handleReadyFn"
    @error="handleErrorFn"
    @launch="handleLaunchFn"
    appid="wx42f86705ea6ec6e1"
    :extinfo="extInfo"
  >
    <div v-is="'script'" type="text/wxtag-template">
      <div :style="style">{{text}}</div>
    </div>
  </wx-open-launch-app>
</template>

<script>
import { getPlatForm } from '@/utils/common'
export default {
  props: {
    // 传递的信息
    extInfo: {
      default: () => {
        return {
          text: '测试',
          name: '测试',
        }
      },
    },
    // 文字提示
    text: {
      type: String,
      default: '立即打开',
    },
    // 展示样式
    style: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  methods: {
    handleReadyFn(e) {
      // alert('ready' + JSON.stringify(e.detail) + 'ready')
    },
    // 监听error 函数
    handleErrorFn(e) {
      // 跳转失败
      // alert(JSON.stringify(e.detail) + '跳转失败')
      // console.log(JSON.stringify(e.detail), '跳转失败')
      this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      // alert('launch' + JSON.stringify(e.detail) + '跳转成功')
      // console.log(JSON.stringify(e.detail), '跳转成功')
    },
    download() {
      let plat = getPlatForm()
      // let url = 'https://a.app.qq.com/o/simple.jsp?pkgname=course.bijixia'
      let url = 'https://download.bijixia.net/'
      // alert(plat + '：palt')
      if (plat == 'Android') {
        window.location.href = url
      } else {
        setTimeout(() => {
          window.location.href = url
        }, 1000)
        window.location.href = this.constants.iosAppLink
      }
    },
  },
}
</script>

<style>
</style>